import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AdminAuthService } from '../services/admin-auth.service';

export const adminRoleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AdminAuthService);
  const router = inject(Router);

  const requiredRoles = route.data['roles'] as string[] | undefined;

  if (!requiredRoles || requiredRoles.length === 0) {
    return true; // No specific role required
  }

  const hasPermission = requiredRoles.some(role => authService.hasRole(role));

  if (hasPermission) {
    return true;
  }

  // Redirect to unauthorized page
  console.warn('Access denied: Insufficient permissions');
  return router.createUrlTree(['/unauthorized']);
};
